<div class="container">
    <div class="me-landing-page-quote">
        <div class="row">
            <div class="col-xs-12">
                <div tabindex="0" class="me-landing-page-quote__header" [innerHTML]="data.headline | storyblokRichtext">
                </div>
            </div>
            <div class="col-xs-12 carousel-container">
                <a *ngIf="!hidePrev" class="carousel-nav__left" (click)="owlCar.prev()">
                    <i class="far fa-chevron-left"></i>
                </a>
                <owl-carousel-o [options]="customOptions" (changed)="getDataCarousel($event)" #owlCar>
                    <ng-container *ngFor="let quote of data['quotes']">
                        <ng-template carouselSlide>
                            <div tabindex="0" class="me-landing-page-quote__carousel-card">
                                <div class="me-landing-page-quote__carousel-card-left">”</div>
                                <div class="me-landing-page-quote__carousel-card-comment">
                                    {{quote.quote}}
                                </div>
                                <div class="me-landing-page-quote__carousel-card-footer">
                                        <div class="quote__footer--rating">
                                        <rating *ngIf="quote.rating > 0" [(ngModel)]="quote.rating" [max]="5" [readonly]="true" style="color: #f4ec71;font-size: 23px;"></rating>
                                        </div>
                                        <div class="quote__footer--user">
                                            <div class="quote__footer--user--avatar">
                                                <img src="{{quote.avatar.filename}}">
                                            </div>
                                            <div class="quote__footer--user--info">
                                                <b>{{quote.name}}</b>
                                                <span>{{quote.role}} - {{quote.date}}</span>
                                            </div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </ng-container>
                </owl-carousel-o>
                <a *ngIf="!hideNext" class="carousel-nav__right" (click)="owlCar.next()">
                    <i class="far fa-chevron-right"></i>
                </a>
            </div>
        </div>
    </div>
</div>
